import { connect } from 'react-redux';

import Shops from './shops';
import { switchItem } from './actions';
import {
  getActiveBrandLogo,
  getActiveId,
  getActiveName,
  getBrandForSwitcher,
  getShopsForSwitcher,
} from './selectors';

const mapStateToProps = state => ({
  user: state.auth.user,
  items: getShopsForSwitcher(state),
  brandItem: getBrandForSwitcher(state),
  activeName: getActiveName(state),
  activeId: getActiveId(state),
  brandLogo: getActiveBrandLogo(state),
});

const mapDispatchToProps = {
  switchItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(Shops);
